import { createSelector } from '@ngrx/store'

import * as fromMenu from '../reducers/menu.reducer'
import { AppState } from '../../../../../store/app.state'

export const selectMenuState = (state: AppState) => state.menu

export const getMenuStatus = createSelector(
  selectMenuState,
  fromMenu.getSelectedItem
)



// WEBPACK FOOTER //
// ./src/app/shared/navbar/menu/store/selectors/menu.selectors.ts